module.exports = __webpack_public_path__ + "img/edunurse_icon.7f9bac5f.png";